import { makeStyles } from '@material-ui/core';
import React from 'react'
import Particles from 'react-particles-js';

const useStyles = makeStyles(theme => ({
    root: {
        zIndex: 1
    },
    root2: {
        backgroundColor: 'rgba(0, 0, 0, 0.7) !important',
        zIndex: 1
    }
}));

const ParticleAnim = ({ children }) => {
    const classes = useStyles();
  return (
    <div>
      <Particles
        params={{
          particles: {
            number: {
              value: 200,
              density: {
                enable: false,
              },
            },
            size: {
              value: 3,
              random: true,
              anim: {
                speed: 4,
                size_min: 0.3,
              },
            },
            line_linked: {
              enable: false,
            },
            move: {
              random: true,
              speed: 1,
              direction: "top",
              out_mode: "out",
            },
          },
          modes: {
            bubble: {
              distance: 250,
              duration: 2,
              size: 0,
              opacity: 0,
            },
            repulse: {
              distance: 400,
              duration: 4,
            },
          },
        }}
        canvasClassName={classes.root2}
        style={{ position: "absolute" }}
      >
        {children}
      </Particles>
    </div>
  );
};

export default ParticleAnim
